export const arrayHasSameElements = <T>(array1: T[], array2: T[]): boolean => {
  let newArray1 = Array.from(new Set(array1))
  let newArray2 = Array.from(new Set(array2))

  newArray1 = newArray1.filter(el => el !== null && el !== ('' as T))
  newArray2 = newArray2.filter(el => el !== null && el !== ('' as T))

  newArray1 = newArray1.sort()
  newArray2 = newArray2.sort()

  if (newArray1.length !== newArray2.length) return false
  return newArray1.every((el, idx) => el === newArray2[idx])
}